import styled from 'styled-components'
import { FormElemGroup } from 'Components/Form'
import Flex from 'Components/Flex'
import SwitchButton from 'Components/Form/SwitchButton'
import AddRecipientMulti from 'Layout/Modals/components/AddRecipientMulti'
import { BREAK_POINT_SM } from '@CSSVars/variables'

export const _BuildingAlertCard = styled.div`
  background: white;
  padding: 30px 32px;
  margin-bottom: 24px;
  position: relative;
  max-width: 888px;
  border-radius: 10px;
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    padding: 20px;

  }
`
export const _FrequencyContainer = styled.div`
  display: flex;
  flex-direction: column;
`
export const _Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  text-align: left;
  margin-bottom: 15px;
`

export const _FrequencySelect = styled.div`
  width: 272px;
  .frequencySelect {
    height: 44px;
  }
  .dropdown {
    width: 272px;
    max-width: 100%;
    right: 0;
    left: unset;
    div:last-child {
      border-radius: 10px;
    }
    top: 44px !important;
  }

`


export const _AlertToggle = styled(SwitchButton)`
  width: 60px;
  height: 24px;

`

export const _DeletingIndicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #d3d3d345;
  z-index: 1;
`

export const _FrequencyGroup = styled(FormElemGroup)`
   max-width: 344px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap:12px;
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    max-width: initial;
  }
`

export const _AddRecipient = styled(Flex)`
  > div {
    width: 100%;
    max-width: 292px;
  }
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    > div {
      max-width: initial;
    }
  }

`
export const _AddRecipientMulti = styled(AddRecipientMulti)`
  > div {
    margin: 0;
  }
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    .moreRecipientText {
      margin: 12px 0;
    }
  }
`
